import { type GridRowModelUpdate } from '@mui/x-data-grid/models/gridRows'
import { type GridAutosizeOptions, type GridColDef, type GridSortModel } from '@mui/x-data-grid-pro'
import { type GridCsvExportOptions } from '@mui/x-data-grid/models/gridExport'
import { type GridExportDisplayOptions } from '@mui/x-data-grid/components/toolbar/GridToolbarExport'
import { type KeyedMutator } from 'swr'

export enum MODE_OPTIONS {
  NONE = 'none',
  COIN = 'coin',
  ACCOUNT = 'account',
  SYMBOL = 'symbol',
}

export interface WrappedDataGridPropsGridMode {
  mode: string
  modeOptions: MODE_OPTIONS[]
  setMode: (mode: MODE_OPTIONS) => void
}

export interface WrappedDataGridPropsStableCoinVisibility {
  stableCoinVisibility: boolean
  toggleStableCoinVisibility: () => void
}

export interface WrappedDataGridPropsToolbarData {
  timestamp: number
  totalCurrAsset: string
  pnlAsset: string
  nextFund: string
  initialBalanceByCoin?: Record<string, string>
  initialExposureByCoin?: Record<string, string>
}

export interface WrappedDataGridProps {
  gridData: {
    rows: GridRowModelUpdate[]
    columns: GridColDef[]
    autosizeOptions: GridAutosizeOptions
    portfolio: string
    sortModel?: GridSortModel
    initialSortModel?: GridSortModel
    csvOptions?: GridCsvExportOptions & GridExportDisplayOptions
  }
  gridMode: WrappedDataGridPropsGridMode
  stableCoinVisibility?: WrappedDataGridPropsStableCoinVisibility
  toolbarData?: WrappedDataGridPropsToolbarData
  styleData?: Record<string, string>
  mutate?: KeyedMutator<any>
}
